import { create } from 'zustand'
import type { GameMode } from '@/game/types'

interface S {
  score: number
  stage: number
  timeRemaining: number
  mode: GameMode
  nickname: string
  gameToken: string // start_game()로 발급받은 서명 토큰(점수 제출 검증용)
  point2xActive: boolean // 이번 게임 포인트 2배 적립 여부(대기실에서 장착)
  set: (p: Partial<S>) => void
}

const NICK_KEY = 'tenblock_nickname'
const loadNick = (): string => {
  try { return localStorage.getItem(NICK_KEY) ?? '' } catch { return '' }
}

export const useGameStore = create<S>((set) => ({
  score: 0,
  stage: 1,
  timeRemaining: 60,
  mode: 'challenge',
  nickname: loadNick(), // 앱 재시작 시에도 이전 닉네임 복원
  gameToken: '',
  point2xActive: false,
  set: (p) => {
    if (p.nickname !== undefined) {
      try { localStorage.setItem(NICK_KEY, p.nickname) } catch { /* 저장 불가 시 무시 */ }
    }
    set(p)
  },
}))
